var map = {
	"./bewolkt.png": 339,
	"./bliksem.png": 234,
	"./buien.png": 27,
	"./hagel.png": 658,
	"./halfbewolkt.png": 14,
	"./halfbewolkt_regen.png": 236,
	"./helderenacht.png": 361,
	"./lichtbewolkt.png": 886,
	"./mist.png": 424,
	"./nachtbewolkt.png": 650,
	"./nachtmist.png": 71,
	"./regen.png": 816,
	"./sneeuw.png": 580,
	"./wolkennacht.png": 425,
	"./zonnig.png": 599,
	"./zwaarbewolkt.png": 62
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64;